import { Divider } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import { MaintenanceOrder } from '../../../../../types/service.types'
import { formatSN } from '../../../../../utils/utils/formatSN'
import { dividerSx } from '../../../../DealersSettings/components/EditSettingsDrawer/components/EditDrawerNotification/style'

const EquipmentStaticData = ({ request }: { request?: MaintenanceOrder }) => {
  return (
    <>
      {request?.oldEquipmentSerialNumber && (
        <DataUnit
          name={'ID изъятого оборудования'}
          value={request?.oldEquipmentSerialNumber}
        />
      )}
      {request?.replacedReceiverSerialNumber && (
        <>
          {(request?.receiverSerialNumber ??
            request?.primaryReceiverSerialNumber) && (
            <DataUnit
              name={'S/N изъятого оборудования'}
              value={formatSN(
                request?.receiverSerialNumber ??
                  request?.primaryReceiverSerialNumber,
              )}
            />
          )}
          {(request?.receiverProduct || request?.primaryReceiverProduct) && (
            <DataUnit
              name={'Модель изъятого оборудования'}
              value={
                request?.receiverProduct ??
                request?.primaryReceiverProduct ??
                '-'
              }
            />
          )}
        </>
      )}
      {(request?.replacedReceiverSerialNumber ||
        request?.oldEquipmentSerialNumber) && <Divider sx={dividerSx} />}
      {request?.oldEquipmentSerialNumber && (
        <DataUnit name={'ID оборудования'} value={request?.equipmentId} />
      )}
      {!request?.oldEquipmentSerialNumber && (
        <DataUnit
          name={'ID оборудования'}
          value={request?.equipmentId ?? 'Не заполнен'}
        />
      )}
      {!request?.replacedReceiverSerialNumber && (
        <>
          {(request?.receiverSerialNumber ??
            request?.primaryReceiverSerialNumber) && (
            <DataUnit
              name={'S/N оборудования'}
              value={formatSN(
                request?.receiverSerialNumber ??
                  request?.primaryReceiverSerialNumber,
              )}
            />
          )}
          {(request?.receiverProduct || request?.primaryReceiverProduct) && (
            <DataUnit
              name={'Модель оборудования'}
              value={
                request?.receiverProduct ??
                request?.primaryReceiverProduct ??
                '-'
              }
            />
          )}
        </>
      )}
      {request?.replacedReceiverSerialNumber && (
        <DataUnit
          name={'S/N оборудования'}
          value={formatSN(request?.replacedReceiverSerialNumber)}
        />
      )}
      {request?.replacedReceiverProduct && (
        <DataUnit
          name='Модель оборудования'
          value={request?.replacedReceiverProduct ?? '-'}
        />
      )}
    </>
  )
}

export default observer(EquipmentStaticData)
